import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import ErrorBoundary from './components/shared/ErrorBoundary/ErrorBoundary';
import AppRoutes from './routes/AppRoutes';
import ApiActivityIndicator from './components/shared/ApiActivityIndicator/ApiActivityIndicator';
import ScrollToTop from './components/shared/ScrollToTop/ScrollToTop';


function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <CartProvider>
          <ApiActivityIndicator />
          <BrowserRouter>
            <ScrollToTop />
            <AppRoutes />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
